var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrayStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12.3816 4.23335L8.62829 3.8926L7.14495 0.419814C7.03544 0.164672 6.78625 0 6.50888 0C6.23152 0 5.98223 0.164672 5.87341 0.419814L4.39007 3.8926L0.636152 4.23335C0.360972 4.25875 0.127951 4.44515 0.0418459 4.70793C-0.0437636 4.9712 0.0352987 5.25997 0.24342 5.4425L3.08064 7.93034L2.24408 11.6148C2.18288 11.8857 2.28803 12.1659 2.51282 12.3284C2.63364 12.4162 2.7756 12.46 2.91805 12.46C3.04046 12.46 3.16297 12.4275 3.27239 12.362L6.50888 10.4268L9.74478 12.362C9.98217 12.5038 10.2807 12.4909 10.505 12.3284C10.7297 12.1659 10.8349 11.8857 10.7737 11.6148L9.93713 7.93034L12.7743 5.4425C12.9824 5.25997 13.0615 4.9718 12.9759 4.70793C12.8903 4.44465 12.6568 4.25825 12.3816 4.23335Z",
    fill: "#5B7486"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayStar);
export default __webpack_public_path__ + "static/media/gray-star.88e143db58f6e83589f99973bcb909f9.svg";
export { ForwardRef as ReactComponent };